import { MutationTree } from 'vuex'
import { IRoomState } from '@/store/room'
import { state as init } from '@/store/room/state'
import { Types, Store, Talk, Current, Top, ScrollTops, Snapshot, Filter, Priority } from '@/store/room/types'

const mutations: MutationTree<IRoomState> = {
  [Types.store]: (state, action: Store) => {
    state.response = action.payload
  },
  [Types.talk]: (state, action: Talk) => {
    state.talk = action.payload
  },
  [Types.current]: (state, action: Current) => {
    state.current = action.payload
  },
  [Types.top]: (state, action: Top) => {
    state.top = action.payload
  },
  [Types.scrollTops]: (state, action: ScrollTops) => {
    state.scrollTops = action.payload
  },
  [Types.snapshot]: (state, action: Snapshot) => {
    state.snapshot = action.payload
  },
  [Types.filter]: (state, action: Filter) => {
    state.filter = action.payload
  },
  [Types.priority]: (state, action: Priority) => {
    state.priority = action.payload
  },
  [Types.refresh]: (state) => {
    Object.assign(state, init())
  }
}

export default mutations
